import produce from 'immer'

export const initialState = {
    categoryData: [],
    currentCategory: {
        cate: [],
        cateinfo: null
    },
    objCateData: null
}

export const CATEGORY_REQUEST = 'CATEGORY_REQUEST'
export const CATEGORY_SUCCESS = 'CATEGORY_SUCCESS'
export const CATEGORY_FAILURE = 'CATEGORY_FAILURE'
export const CURRENT_CATEGORY_REQUEST = 'CURRENT_CATEGORY_REQUEST'
export const CURRENT_CATEGORY_SUCCESS = 'CURRENT_CATEGORY_SUCCESS'
export const CURRENT_CATEGORY_FAILURE = 'CURRENT_CATEGORY_FAILURE'

export default (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case CATEGORY_REQUEST: {
                break
            }
            case CATEGORY_SUCCESS: {
                const objCate = {}
                const dataS = (data) => {
                    data.forEach(v => {
                        objCate[v.cate_id] = v
                        if (v.child_count > 0) {
                            dataS(v.child)
                        }
                    })
                }
                dataS(action.data)


                draft.categoryData = action.data
                draft.objCateData = objCate
                break
            }
            case CATEGORY_FAILURE: {
                draft.categoryData = action.data
                break
            }
            case CURRENT_CATEGORY_REQUEST: {
                break
            }
            case CURRENT_CATEGORY_SUCCESS: {
                const currentCate = action.data
                const cateArr = currentCate.cate[0].child[0]
                const cate1 = cateArr?.cate_id
                const cate2 = cateArr?.child?.[0]?.cate_id
                const cate3 = cateArr?.child?.[0]?.child?.[0]?.cate_id
                const cate4 = cateArr?.child?.[0]?.child?.[0]?.child?.[0]?.cate_id
                draft.currentCategory = action.data
                draft.currentCategory.reduce = {cate1, cate2, cate3, cate4}
                break
            }
            case CURRENT_CATEGORY_FAILURE: {
                break
            }
            default: {
                break
            }
        }
    })
}



// WEBPACK FOOTER //
// ./src/estimate_list/reducers/category.js